import ApiService from "../../../commons/api/api_service";
import BaseResponse from "../../../commons/api/base_response";
import { Endpoints } from "../../../commons/api/endpoints";
import { ProviderVM } from "../../../commons/base/providers/view_model";
import GetTransferHistory, {
    TransferHistoryDetailModel,
    TransferHistoryModel,
} from "../models/tranfer_history_response";

export default class TransferHistoryViewModel extends ProviderVM {
    isLoading: boolean = true;
    isLoadingDetail: boolean = false;
    errorMessage: string = "";
    transferHistory: TransferHistoryModel[] = [];
    items: TransferHistoryDetailModel[] = [];
    fixItems: TransferHistoryDetailModel[] = [];
    isShowmodal: boolean = false;
    selectedCode: string = "";
    selectedFilter: string = "code";
    searchQuery: string = "";
    filteredData: TransferHistoryModel[] = [];
    isFilter: boolean = false;

    get itemsWithFixItems() {
        return this.items.map((item) => {
            const fixItem = this.fixItems.find(
                (fixItem) => fixItem.master_item_id === item.master_item_id
            );

            return {
                ...item,
                fixItem,
            };
        });
    }

    get selectedDetail() {
        return this.transferHistory.find(
            (history) => history.code === this.selectedCode
        );
    }

    constructor() {
        super();
        this.loadData();
    }

    setFilter(value: string) {
        this.emit(() => {
            this.selectedFilter = value;
        });
    }

    setSeachQuery(value: string) {
        this.emit(() => {
            this.searchQuery = value;
        });
    }

    searchData() {
        this.emit(() => {
            this.errorMessage = "";
            this.isFilter = true;
        });

        this.filteredData = this.transferHistory.filter((history) => {
            if (this.selectedFilter === "receiver") {
                return history.to_location_name
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase());
            } else if (this.selectedFilter === "sender") {
                return history.from_location_name
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase());
            } else {
                return history.code
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase());
            }
        });
    }

    clearFilter() {
        this.emit(() => {
            this.isFilter = false;
            this.searchQuery = "";
            this.selectedFilter = "code";
            this.filteredData = [];
        });
    }

    loadData() {
        this.emit(() => {
            this.isLoading = true;
            this.errorMessage = "";
        });

        ApiService.fetch<{}, BaseResponse<GetTransferHistory>>(
            Endpoints.getTransferHistory,
            {
                onSuccess: (response) => {
                    console.log(response.data);
                    this.emit(() => {
                        this.isLoading = false;
                        this.transferHistory =
                            response.data?.transfer_history ?? [];
                    });
                },
                onFailure: (error) => {
                    this.emit(() => {
                        this.errorMessage = `${error}`;
                        this.isLoading = false;
                    });
                },
            }
        );
    }

    loadDetail(code: string) {
        this.emit(() => {
            this.isLoadingDetail = true;
            this.errorMessage = "";
            this.isShowmodal = true;
            this.selectedCode = code;
        });

        ApiService.fetch<{}, BaseResponse<GetTransferHistory>>(
            Endpoints.getTransferFixItems,
            {
                parameters: { code },
                onSuccess: (response) => {
                    console.log(response.data);
                    this.emit(() => {
                        this.isLoadingDetail = false;
                        this.items = response.data?.items ?? [];
                        this.fixItems = response.data?.fixItems ?? [];
                    });
                },
                onFailure: (error) => {
                    this.emit(() => {
                        this.errorMessage = `${error}`;
                        this.isLoadingDetail = false;
                    });
                },
            }
        );
    }

    closeDetail() {
        this.emit(() => {
            this.isShowmodal = false;
            this.selectedCode = "";
        });
    }

    retryAction() {
        this.loadData();
    }
}
